<template>
	<div
		:class="{
			'service-item': true,
		}"
		@click="chooseServiceClick(item, index)"
	>
		<div :class="{ 'item-bg': true }">
			<div class="item-bg-type">
				<div
					:class="{
						'item-icon-wrap-on': true,
					}"
				>
					<div
						:class="{
							'nas-icon': false,
							'router-icon': false,
							'winpc-icon': true,
						}"
					>
						<div
							:class="{
								'item-text-wrap-on': true,
								'item-text-wrap-off': false,
							}"
						></div>
					</div>
				</div>
			</div>
		</div>
		<div class="item-limit" v-if="index > max_index - 1"></div>
		<div class="item-content">
			<div
				class="item-del"
				@click="removeServiceClick(item, index)"
				v-if="item.type != 'auto'"
			></div>
			<div class="item-name-group">
				<div class="item-text">
					<div
						class="item-name"
						:title="item.name"
						v-if="!isShowNameEdit"
						@click="showNameEdit"
					>
						{{ item.name }}
					</div>
					<div class="item-name-edit" v-else>
						<input
							v-model="name"
							id="name"
							@blur="saveNameEdit(item)"
							@keydown.enter="saveNameEdit(item)"
						/>
					</div>
					<div class="item-ip">
						<div class="item-ip-dot"></div>
						{{ item.mac }}
					</div>
				</div>

				<div class="item-type-text">远程{{ item.type_name }}</div>
			</div>
			<div class="remote-btn remote-btn-open" @click="openClick(item)">
				开机唤醒
				<div class="remote-btn-bg"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	data: function () {
		return {
			name: "",
			isShowNameEdit: false,
		};
	},
	props: ["item", "index", "type", "uncheckList", "max_index"],
	methods: {
		...mapActions(["sendUserlog"]),
		showNameEdit: function () {
			if (this.item.type == "auto") {
				return;
			}
			this.isShowNameEdit = true;
			setTimeout(function () {
				document.getElementById("name").focus();
			}, 500);
		},
		hideNameEdit: function () {
			this.isShowNameEdit = false;
		},
		saveNameEdit: function (item) {
			// console.log("saveNameEdit");
			// item.name = this.name;
			this.hideNameEdit();
			item.name = this.name;
			this.$emit("nameEditClick", item);
		},
		controlClick: function (item) {
			console.log("controlClick");
			let _that = this;
			if (_that.index > _that.max_index - 1) {
				// console.log("limitClick");
				_that.$emit("limitClick", item);
				_that.sendUserlog([
					"service_limit_control",
					_that.$store.state.user.vip_left > 0 ? 1 : 0,
				]);
			} else {
				this.$emit("controlClick", item);
			}
		},
		openClick: function (item) {
			let _that = this;
			if (_that.index > _that.max_index - 1) {
				_that.$emit("limitClick");
				_that.sendUserlog([
					"service_limit_open",
					_that.$store.state.user.vip_left > 0 ? 1 : 0,
				]);
			} else {
				_that.$emit("openClick", item);
			}
		},
		removeServiceClick: function (item, index) {
			this.$emit("removeServiceClick", item, index);
		},
		chooseServiceClick: function (item, index) {
			if (this.type != "search") {
				return;
			}
			this.$emit("chooseServiceClick", item, index);
		},
	},
	mounted: function () {
		this.name = this.item.uname
			? this.item.uname
			: this.item.port_name
			? this.item.port_name
			: this.item.name;
	},
};
</script>

<style lang="less" scoped>
.service-item {
	display: inline-block;
	position: relative;
	margin-left: 10px;
	margin-right: 10px;
	margin-top: 10px;
	margin-bottom: 5px;
	width: 285px;
	// width: 205px\0;
	height: 120px;
	box-sizing: border-box;
	background-color: #fcfdff;
	border-radius: 6px;
	border: 1px solid #d7deec;
	vertical-align: top;

	.item-bg {
		position: absolute;
		right: 0;
		top: 0;
		width: 147px;
		height: 136px;
		background-image: url(../../assets/home/node/node_item_bg2.svg);
		background-position: top right;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		z-index: 0;

		.item-bg-type {
			position: absolute;
			right: 34px;
			top: 24px;
			width: 38px;
			height: 38px;
		}

		.item-icon-wrap-on {
			width: 100%;
			height: 100%;
			.nas-icon,
			.other-icon,
			.router-icon,
			.winpc-icon {
				width: 100%;
				height: 100%;
				background-repeat: no-repeat;
				background-size: 100% auto;
				background-position: center;
			}
			.nas-icon {
				background-image: url("../../assets/home/node/nas_online.svg");
			}
			.router-icon {
				background-image: url("../../assets/home/node/router_online.svg");
			}
			.winpc-icon {
				background-image: url("../../assets/home/node/pc_online2.svg");
			}
		}
		.item-icon-wrap-off {
			width: 100%;
			height: 100%;
			.nas-icon,
			.other-icon,
			.router-icon,
			.winpc-icon {
				width: 100%;
				height: 100%;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				background-position: center;
			}
			.nas-icon {
				background-image: url("../../assets/home/node/nas_offline.svg");
			}
			.router-icon {
				background-image: url("../../assets/home/node/router_offline.svg");
			}
			.winpc-icon {
				background-image: url("../../assets/home/node/pc_offline2.svg");
			}
		}
	}

	.item-bg.item-bg-off {
		background-image: url(../../assets/home/node/node_item_offline_bg2.png);
	}

	.item-limit {
		position: absolute;
		right: 27px;
		top: 40px;
		width: 24px;
		height: 24px;
		background-image: url(../../assets/home/node/node_service_limit.svg);
		background-size: 100% 100%;
	}

	.item-content {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	.item-name-group {
		padding-top: 15px;
		z-index: 1;

		.item-type-text {
			display: none;
			background-color: #cad9fc;
			border-radius: 3px;
			font-size: 12px;
			width: 66px;
			height: 24px;
			line-height: 24px;
			margin-left: 28px;
			text-align: center;
			color: #1f5de3;
			margin-top: 5px;
			transform: scale(0.8);
			transform-origin: left;
		}

		.item-icon-wrap-on,
		.item-icon-wrap-off {
			position: relative;
			margin-left: 15px;
			margin-right: 10px;
			width: 48px;
			height: 48px;
			display: inline-block;
			vertical-align: top;

			.item-text-wrap-on {
				position: absolute;
				left: 50%;
				transform: translate(-50%, 0);
				bottom: -8px;
				width: 31px;
				height: 14px;
				line-height: 14px;
				border-radius: 41px;
				background-color: #dee8ff;
				border: 1px solid #f5f8ff;
				text-align: center;

				div {
					color: #1f5de3;
					font-size: 12px;
					transform: scale(0.75);
				}
			}
			.item-text-wrap-off {
				background-color: #999999;
				border: none;
				div {
					color: #f0f0f0;
				}
			}
		}

		.item-text {
			display: inline-block;
			vertical-align: top;
			margin-left: 30px;
			.item-name {
				width: 126px;
				color: #1b358b;
				font-size: 15px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-weight: bolder;
				height: 30px;
				line-height: 30px;
			}
			.item-name-edit {
				background-color: #ffffff;
				width: 120px;
				height: 30px;
				line-height: 30px;
				border-radius: 15px;
				border: 1px solid #eeeeee;
				box-shadow: 0px 0px 2px 0px #eeeeee;
				box-sizing: border-box;
				margin-left: -2px;
				input {
					color: #1b358b;
					font-weight: bolder;
					background-color: transparent;
					width: 110px;
					margin-left: 7px;
					height: 28px;
					line-height: 28px;
					font-size: 15px;
					margin-top: 0px;
					display: inline-block;
					vertical-align: top;
				}
			}
			.item-ip {
				font-size: 12px;
				color: #1f5de3;
				margin-top: 0px;
				height: 15px;
				line-height: 15px;
				.item-ip-dot {
					display: inline-block;
					vertical-align: top;
					width: 4px;
					height: 4px;
					background-color: #1f5de3;
					border-radius: 2px;
					margin-top: 5px;
				}
			}
		}
	}

	.remote-btn {
		margin-top: 11px;
		margin-bottom: 10px;
		width: 90px;
		height: 36px;
		margin-left: 30px;
		color: #ffffff;
		font-size: 12px;
		line-height: 36px;
		text-align: center;
		box-shadow: 0px 4px 16px 1px rgba(54, 58, 67, 0.16);
		// background-color: #dbe5fb;
		// box-shadow: inset 0px 1px 1px 1px rgba(32, 37, 66, 0.1);
		// background-image: url(../../assets/home/node/control_btn_bg.svg);
		background-color: #1f5de3;
		background-size: 100% 100%;
		border-radius: 18px;
		cursor: pointer;
		overflow: hidden;
		border-radius: 18px;

		position: relative;
		.remote-btn-bg {
			display: none;
			background-color: #1b358b;
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
			animation-name: moveRight;
			animation-duration: 1.5s;
			animation-fill-mode: forwards;
			opacity: 0.3;
		}
	}
	.remote-btn:hover {
		background-color: #015eff;
		.remote-btn-bg {
			display: block;
		}
	}
	.remote-btn-unactive {
		background-color: #cc943d;
		background: #cccccc;
		color: #603618;
		color: #999999;
	}
	.remote-btn-unactive:hover {
		background: #cccccc;
	}
	.remote-btn-open {
		// background-image: none;
		// background-color: #1f5de3;
	}
	.remote-btn-open:hover {
		// background-image: none;
		// background-color: #477ef7;
	}

	.service-choose-icon {
		position: absolute;
		bottom: 0px;
		right: 0px;
		width: 36px;
		height: 36px;
		background-image: url("../../assets/home/node/find_icon22.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.service-choose-icon:hover {
		cursor: pointer;
	}
	.service-choose-icon-unactive {
		background-image: url("../../assets/home/node/find_icon11.png");
	}
}

.service-item.service-item-offline {
	background-color: #f6f6f6;
	border-color: #eaebea;

	.item-name-group {
		.item-text {
			.item-name {
				color: #666666;
			}

			.item-ip {
				color: #999999;
				.item-ip-dot {
					background-color: #999999;
				}
			}
		}
	}
}

.service-item.service-item-offline:hover {
	background-color: #f6f6f6;
}

.service-item:hover {
	border: 1px solid #3771ef;
	// box-shadow: 0 4px 16px 1px rgba(125, 91, 19, 0.56);
	box-shadow: 0px 4px 16px 1px rgba(121, 135, 165, 0.16);
	background-color: #edf3ff;
}

.service-item:hover {
	position: relative;

	.item-del {
		position: absolute;
		right: 8px;
		bottom: 8px;
		width: 20px;
		height: 20px;
		background-image: url("../../assets/home/node/service_device_icon_del.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		cursor: pointer;
	}
}

.service-item.service-item-search {
	background-color: #fcfdff;
	height: 100px;
	cursor: pointer;
	overflow: hidden;
	border-radius: 8px;

	.item-text {
		.item-name {
			width: 150px;
		}
	}

	.item-bg {
		display: block;
		top: 13px;
		right: 25px;
		width: 75px;
		height: 75px;
		background-image: url(../../assets/home/node/node_item_bg3.svg);
		background-size: 100% 100%;
		background-position: center center;
		.item-bg-type {
			right: 22px;
			top: 22px;
		}
	}

	.item-name-group {
		padding-top: 15px;
	}

	.item-type-text {
		display: block;
	}

	.remote-btn {
		display: none;
	}
	.remote-btn:hover {
		background-color: #dbe5fb;
	}
}

.service-item.service-item-search:hover {
	background-color: #edf3ff;
}

.service-item.service-item-search.service-item-offline {
	background-color: #f6f6f6;

	.item-bg.item-bg-off {
		background-image: url(../../assets/home/node/node_item_offline_bg3.svg);
	}
	.item-type-text {
		background-color: #999999;
		color: #ffffff;
	}
}
.service-item.service-item-limit {
	.remote-btn {
		background-image: none;
		background-color: #1f5de3;
		background-image: url(../../assets/home/node/node_service_limit.png);
		background-size: 17px 17px;
		background-position: 18px center;
		padding-left: 40px;
		padding-right: 20px;
		text-align: left;
		width: auto;
		display: inline-block;
		background-repeat: no-repeat;
	}
}

@keyframes moveRight {
	from {
		left: 0;
	}
	to {
		left: 100%;
	}
}

.name-wrap {
	width: 100%;
	height: 26px;
	line-height: 26px;
	border-top: 1px solid rgba(202, 210, 214, 0.6);
	.name-icon {
		display: inline-block;
		vertical-align: top;
		margin-top: 5px;
		margin-left: 5px;
		width: 16px;
		height: 16px;
		background-image: url("../../assets/remote/dot.svg");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.name-text {
		display: inline-block;
		vertical-align: top;
		font-weight: 400;
		font-size: 12px;
		line-height: 26px;
		color: #999999;
	}
}
</style>